import type { FunctionComponent } from "react"

import { CardLayout } from "@/modules/companies/client/components/RecruitmentPatternInformation/CardLayout/CardLayout"
import { Column } from "@/modules/companies/client/components/RecruitmentPatternInformation/SectorCard/Column/Column"
import { Raw } from "@/modules/companies/client/components/RecruitmentPatternInformation/SectorCard/Raw/Raw"
import { useCompanyAnalyticsData } from "@/modules/companies/client/components/RecruitmentPatternInformation/useCompanyAnalyticsData"
import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./SectorCard.module.css"

export const SectorCard: FunctionComponent = () => {
  const { dataCompany } = useCompanyFetch()
  const { hasEnoughData, topPositions } = useCompanyAnalyticsData()
  const { t } = useTranslation(["companies_client"])

  if (!dataCompany) return null
  if (!hasEnoughData || !topPositions) return null

  const { filteredPosition, scale } = topPositions

  const stepScale = Math.floor(scale / 4)

  return (
    <CardLayout
      title={t("companies_client.recruitmentPatternInformation.sector.title", {
        name: dataCompany.page.name,
      })}
      data-testid="recruitementPattern_sector"
    >
      <div className={styles.graph}>
        <div className={styles.grid} aria-hidden="true">
          <Column value={0} />
          <Column value={stepScale} />
          <Column value={stepScale * 2} />
          <Column value={stepScale * 3} />
          <Column value={scale} />
        </div>
        <ul className={styles.data}>
          {filteredPosition.map(position => {
            const { publicationsCount, positionCategoryName } = position
            return (
              <Raw
                key={positionCategoryName}
                value={publicationsCount}
                name={positionCategoryName}
                lineSize={(publicationsCount / scale) * 100}
              />
            )
          })}
        </ul>
      </div>
    </CardLayout>
  )
}
